// extracted by mini-css-extract-plugin
export default {"container":"IconButton_container__f1OB0","icon":"IconButton_icon__gD-f7","title":"IconButton_title__Q15CO","disabled":"IconButton_disabled__TcnjJ"};